class VisualFilters extends HTMLElement {
  constructor() {
    super()

    this._doInit = this._doInit.bind(this)
  }

  connectedCallback() {
    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: 2.4,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerGroup: 1,
      navigation: {
        nextEl: '.shop-by-carousel--icon-next',
        prevEl: '.shop-by-carousel--icon-previous',
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
        },
      },
    }

    this.$swiper = new Swiper('.js-visual-filters-swiper', option)
    this.$swiper.on('init', this._doInit)
    this.$swiper.on('resize', (swiper) => {
      this._doInit()
    })
    this.$swiper.init()
  }

  _doInit() {
    const imgWrapper = this.$swiper.el.querySelector(
      '.shop-by-section--card_image',
    )
    if (imgWrapper) {
      const h = imgWrapper.getBoundingClientRect().height
      this.style.setProperty('--block-height', `${h}px`)
    }
  }
}

customElements.define('visual-filters', VisualFilters)
